import gql from "graphql-tag";

export const switchClientMutation = gql`
  mutation switchClient($clientCode: String!) {
    switchClient(clientCode: $clientCode) {
      token
    }
  }
`;
